export default {
  he: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'שורות בדף:',
        rowsPerPageAll: 'הכל',
        pageText: '{0}-{1} מתוך {2}',
        noResultsText: 'לא נמצאו רשומות',
        nextPage: 'דף הבא',
        prevPage: 'דף קודם'
      },
      dataTable: {
        rowsPerPageText: 'שורות בדף:'
      },
      noDataText: 'אין מידע',
    }
  }
}


// WEBPACK FOOTER //
// ./src/i18n/messages.js